export const customLabels = {
  companyname: { value: "Company", unit: "" },
  marketCapitalization_latest: {
    value: "Market Cap Latest",
    unit: "(Rs. Crs.)"
  },
  ev_per_ebitda_latest: { value: "EV/EBITDA", unit: "" },
  ev_per_ebitda: { value: "EV/EBITDA", unit: "" },
  p_per_s: { value: "Price / Sales", unit: "" },
  latest_net_profit: { value: "Profit", unit: "(Rs. Crs.)" },
  latest_pe_ratio: { value: "P/E", unit: "" },
  pe_ratio: { value: "P/E", unit: "" },
  pb_ratio: { value: "P/B", unit: "" },
  latest_pb_ratio: { value: "P/B", unit: "" },
  peg: { value: "PEG", unit: "" },
  standard_deviation: { value: "Standard Deviation", unit: "" },
  dividend_yield: { value: "Dividend Yield", unit: "(%)" },
  beta: { value: "Beta", unit: "" },
  latest_roe: { value: "ROE", unit: "(%)" },
  latest_sales: { value: "Sales", unit: "(Rs. Crs.)" },
  net_sales: { value: "Net Sales", unit: "(Rs. Crs.)" },
  latest_sales_growth: { value: "Sales Growth", unit: "(%)" },
  latest_total_debt_per_net_worth: { value: "Debt/NW", unit: "" },
  total_debt_per_net_worth: { value: "Debt/NW", unit: "" },
  one_year_return: { value: "1 Yr Return", unit: "" },
  ebitDA: { value: "EBITDA", unit: "(Rs. Crs.)" },
  ebitDA_per_sales: { value: "EBITDA Margin", unit: "(%)" },
  eps_after_minority_interest_adj: {
    value: "EPS after minority Int. Adj.",
    unit: "(Rs.)"
  },
  eps_before_minority_adj: {
    value: "EPS before minority Int. Adj.",
    unit: "(Rs.)"
  },
  eps: { value: "EPS", unit: "(Rs.)" },
  profit: { value: "Net Profit", unit: "(Rs. Crs.)" },
  net_profit: { value: "Profit", unit: "(Rs. Crs.)" },
  profit_growth: { value: "Profit Growth", unit: "(%)" },
  sales: { value: "Sales", unit: "(Rs. Crs.)" },
  sales_growth: { value: "Sales Growth", unit: "(%)" },
  roe: { value: "ROE", unit: "(%)" },
  total_debt_per_equity: { value: "Debt/NW", unit: "" },
  last_year_price_return: { value: "1 Yr Return", unit: "(%)" },
  assets: { value: "Total Assets", unit: "(Rs. Crs.)" },
  FIIHolding: { value: "FII Holding", unit: "" },
  MutualFundHolding: { value: "Mutual Fund Holding", unit: "" },
  PromoterHolding: { value: "Promoter Holding", unit: "" },
  Promoter_PledgeSharesPercentage: {
    value: "Pledge Shares percentage",
    unit: ""
  },
  capital_adequacy_ratio: { value: "CAR (%)", unit: "" },
  percent_net_non_performing_assets: { value: "NNPA (%)", unit: "" },
  Others: { value: "Others", unit: "" },
  large: { value: "Large Cap", unit: "" },
  midlevel: { value: "Mid Cap", unit: "" },
  small: { value: "Small Cap", unit: "" },
  micro: { value: "Micro Cap", unit: "" }
};

export const customBankLabels = {
  companyname: { value: "Company", unit: "" },
  marketCapitalization_latest: {
    value: "Market Cap Latest",
    unit: "(Rs. Crs.)"
  },
  ev_per_ebitda_latest: { value: "EV/EBITDA", unit: "" },
  ev_per_ebitda: { value: "EV/EBITDA", unit: "" },
  p_per_s: { value: "Price / Sales", unit: "" },
  latest_net_profit: { value: "Profit", unit: "(Rs. Crs.)" },
  latest_pe_ratio: { value: "P/E", unit: "" },
  pe_ratio: { value: "P/E", unit: "" },
  pb_ratio: { value: "P/B", unit: "" },
  latest_pb_ratio: { value: "P/B", unit: "" },
  peg: { value: "PEG", unit: "" },
  standard_deviation: { value: "Standard Deviation", unit: "" },
  dividend_yield: { value: "Dividend Yield", unit: "(%)" },
  beta: { value: "Beta", unit: "" },
  latest_roe: { value: "ROE", unit: "(%)" },
  latest_sales: { value: "Total Income", unit: "(Rs. Crs.)" },
  net_sales: { value: "Total Income", unit: "(Rs. Crs.)" },
  latest_sales_growth: { value: "Total Income Growth", unit: "(%)" },
  latest_total_debt_per_net_worth: { value: "Debt/NW", unit: "" },
  total_debt_per_net_worth: { value: "Debt/NW", unit: "" },
  one_year_return: { value: "1 Yr Return", unit: "" },
  ebitDA: { value: "EBITDA", unit: "(Rs. Crs.)" },
  ebitDA_per_sales: { value: "EBITDA Margin", unit: "(%)" },
  eps_after_minority_interest_adj: {
    value: "EPS after minority Int. Adj.",
    unit: "(Rs.)"
  },
  eps_before_minority_adj: {
    value: "EPS before minority Int. Adj.",
    unit: "(Rs.)"
  },
  eps: { value: "EPS", unit: "(Rs.)" },
  profit: { value: "Net Profit", unit: "(Rs. Crs.)" },
  net_profit: { value: "Profit", unit: "(Rs. Crs.)" },
  profit_growth: { value: "Profit Growth", unit: "(%)" },
  sales: { value: "Total Income", unit: "(Rs. Crs.)" },
  sales_growth: { value: "Total Income Growth", unit: "(%)" },
  roe: { value: "ROE", unit: "(%)" },
  total_debt_per_equity: { value: "Debt/NW", unit: "" },
  last_year_price_return: { value: "1 Yr Return", unit: "(%)" },
  assets: { value: "Total Assets", unit: "(Rs. Crs.)" },
  FIIHolding: { value: "FII Holding", unit: "" },
  MutualFundHolding: { value: "Mutual Fund Holding", unit: "" },
  PromoterHolding: { value: "Promoter Holding", unit: "" },
  Promoter_PledgeSharesPercentage: {
    value: "Pledge Shares percentage",
    unit: ""
  },
  capital_adequacy_ratio: { value: "CAR (%)", unit: "" },
  percent_net_non_performing_assets: { value: "NNPA (%)", unit: "" },
  Others: { value: "Others", unit: "" },
  large: { value: "Large Cap", unit: "" },
  midlevel: { value: "Mid Cap", unit: "" },
  small: { value: "Small Cap", unit: "" },
  micro: { value: "Micro Cap", unit: "" }
};

export const months = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec"
];
export const z1Ratings = [
  // { color: '#F0534F', label: 'Not Attractive' },
  { color: "#FFFFFF", label: "" },
  { color: "#CC5E5E", label: "Rebalance" },
  { color: "#CC5E5E", label: "Unsatisfactory" },
  { color: "#FFC533", label: "Satisfactory" },
  { color: "#FFC533", label: "Good" },
  { color: "#62B58F", label: "Excellent" }
];
export const z1CompanyRatings = [
  // { color: '#F0534F', label: 'Not Attractive' },
  { color: "#FFFFFF", label: "" },
  { color: "#CC5E5E", label: "Strong Sell" },
  { color: "#CC5E5E", label: "Sell" },
  { color: "#FFC533", label: "Hold" },
  { color: "#62B58F", label: "Buy" },
  { color: "#62B58F", label: "Strong Buy" }
];
export const businessRatings = [
  { color: "#FFFFFF", label: "" },
  { color: "#CC5E5E", label: "Poor" },
  { color: "#CC5E5E", label: "Unsatisfactory" },
  { color: "#CC5E5E", label: "Satisfactory" },
  { color: "#FFC533", label: "Good" },
  { color: "#FFC533", label: "V.Good" },
  { color: "#62B58F", label: "Excellent" },
  { color: "#62B58F", Label: "Superior" }
];

export const valuationRatings = [
  // { color: '#F0534F', label: 'Not Attractive' },
  { color: "#FFFFFF", label: "" },
  { color: "#CC5E5E", label: "Not Attractive" },
  { color: "#CC5E5E", label: "Less Attractive" },
  { color: "#CC5E5E", label: "Moderately Attractive" },
  { color: "#FFC533", label: "Attractive" },
  { color: "#FFC533", label: "V. Attractive" },
  { color: "#62B58F", label: "V. Attractive" },
  { color: "#62B58F", label: "V. Attractive" }
];
export const quaterlyRatings = [
  { color: "#FFFFFF", label: "" },
  { color: "#CC5E5E", label: "Poor" },
  { color: "#CC5E5E", label: "Weak" },
  { color: "#CC5E5E", label: "Average" },
  { color: "#FFC533", label: "Good" },
  { color: "#FFC533", label: "Outstanding" },
  { color: "#62B58F", label: "Outstanding" },
  { color: "#62B58F", label: "Outstanding" }
];

export const debtRatings = [
  { color: "#FFFFFF", label: "" },
  { color: "#CC5E5E", label: "Poor" },
  { color: "#CC5E5E", label: "Unsatisfactory" },
  { color: "#CC5E5E", label: "Satisfactory" },
  { color: "#FFC533", label: "Good" },
  { color: "#FFC533", label: "V.Good" },
  { color: "#62B58F", label: "Excellent" },
  { color: "#62B58F", Label: "Superior" }
];

export const equityRatings = [
  { color: "#FFFFFF", label: "" },
  { color: "#CC5E5E", label: "Poor" },
  { color: "#CC5E5E", label: "Unsatisfactory" },
  { color: "#CC5E5E", label: "Satisfactory" },
  { color: "#FFC533", label: "Good" },
  { color: "#FFC533", label: "V.Good" },
  { color: "#62B58F", label: "Excellent" },
  { color: "#62B58F", Label: "Superior" }
];
export const overallRatings = [
  { color: "#FFFFFF", label: "" },
  { color: "#CC5E5E", label: "Poor" },
  { color: "#CC5E5E", label: "Unsatisfactory" },
  { color: "#CC5E5E", label: "Satisfactory" },
  { color: "#FFC533", label: "Good" },
  { color: "#FFC533", label: "V.Good" },
  { color: "#62B58F", label: "Excellent" },
  { color: "#62B58F", Label: "Superior" }
];

export const getRiskColor = (value: any): string => {
  //console.log("####value####", value);
  const riskValue = String(value || "")
    .toLowerCase()
    .trim();

  switch (riskValue) {
    case "low":
      return "#00A550";

    case "low to moderate":
      return "#8DC63F";

    case "moderate":
      return "#dbd21d";

    case "maintain":
      return "#FFC533";

    case "moderately high":
      return "#F7941D";

    case "high":
      return "#F15A24";

    case "very high":
      return "#ED1C24";

    case "buy":
      return "#62B58F";

    case "rebalance":
      return "#CC5E5E";

    case "strong buy":
      return "#62B58F";

    case "strong sell":
      return "#CC5E5E";

    case "hold":
      return "#FFC533";

    case "outstanding":
      return "#ffc533";

    case "excellent":
      return "#62B58F";

    case "superior":
      return "#62B58F";

    case "very attractive":
      return "#18af6b";

    case "attractive":
      return "#42c98c";

    case "v. attractive":
      return "#18af6b";

    case "moderately attractive":
      return "#42c98c"; 
    /* { color: "#CC5E5E", label: "Moderately Attractive" }, */

    case "less attractive":
      return "#CC5E5E";

    case "not attractive":
      return "#CC5E5E";

    case "poor":
      return "#CC5E5E";

    case "weak":
      return "#CC5E5E";

    case "average":
      return "#CC5E5E";

    case "sell":
      return "#CC5E5E";

    case "unsatisfactory": 
      return "#CC5E5E";

    case "very good":
      return "#18af6b";

    case "v.good":
      return "#18af6b";

    case "good":
      return "#18af6b";

    case "satisfactory":
      return "#FFC533";

    case "rebalance":
      return "#CC5E5E";
      
    case "rebalance":
      return "#CC5E5E";

    default:
      return "#000";
  }
};
